import store from "@/store";
import { io } from "socket.io-client";

class WebSocketManager {
	constructor() {
		this.connections = new Map();
	}

	_generateKey(namespace, path) {
		return `${namespace}::${path}`;
	}

	connect(namespace, path) {
		const key = this._generateKey(namespace, path);
		const token = store.getters.getToken;

		if (this.connections.has(key)) {
			console.warn(`⚠️ WebSocket already connected to ${key}`);
			return this._createSocketWrapper(this.connections.get(key), namespace, path);
		}

		const socket = io(namespace, {
			path,
			auth: { token },
			reconnection: true,
			reconnectionAttempts: 10,
			reconnectionDelay: 1000,
			withCredentials: true,
			transports: ["websocket"],
		});

		socket.on("connect", () => {
			console.log(`✅ Connected to ${key}`);
		});

		socket.on("disconnect", (reason) => {
			console.warn(`⚠️ Disconnected from ${key}: ${reason}`);
		});

		socket.on("connect_error", (err) => {
			console.error(`❌ Connection error on ${key}: ${err.message}`);
		});

		this.connections.set(key, socket);

		return this._createSocketWrapper(socket, namespace, path);
	}

	_createSocketWrapper(socket, namespace, path) {
		const key = this._generateKey(namespace, path);

		return {
			on: (event, handler) => {
				socket.off(event, handler);
				socket.on(event, handler);
			},
			off: (event) => {
				socket.off(event);
			},
			emit: (event, data) => {
				socket.emit(event, data);
			},
			disconnect: () => {
				socket.disconnect();
				this.connections.delete(key);
				console.log(`🛑 Disconnected from ${key}`);
			},
		};
	}
}

export default new WebSocketManager();
